module.exports = __webpack_public_path__ + "img/icons8-cancel.efac8f54.svg";